export default "__VITE_PUBLIC_ASSET__8f2d389a__"